module.exports = __webpack_public_path__ + "static/media/NewHelloFarmerLogo.c4bc5b96.svg";